import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Home: React.FC = () => {
	const navigate = useNavigate();

	useEffect(() => {
		navigate('/home');
	}, []);

	return <div className="bg-background w-full h-full"></div>;
};

export default Home;
